import React from 'react';
import './GlobalFooter.css';

const GlobalFooter = ({ visible = true }) => {
  return (
    <footer className={`global-footer ${visible ? 'visible' : ''}`} role="contentinfo" aria-hidden={!visible}>
      <div className="global-footer-inner">
        <div className="footer-links" aria-label="フッターリンク">
          <a href="/terms" className="footer-link">利用規約</a>
          <span className="dot">·</span>
          <a href="/privacy" className="footer-link">プライバシーポリシー</a>
          <span className="dot">·</span>
          <a href="/license" className="footer-link">ライセンス</a>
          <span className="dot">·</span>
          <a href="/contact" className="footer-link">お問合せ</a>
          <span className="dot">·</span>
          <a href="/company" className="footer-link">運営元</a>
        </div>
        <div className="footer-copy">© 2026 Garlic Hamster</div>
      </div>
    </footer>
  );
};

export default GlobalFooter;
